import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { ModalNextProvider } from '@jutro/components';
import _ from 'lodash';
import { log } from '@jutro/logger';
import { PromptService } from './PromptService';
import { handleAction } from './actionHelper';
export var routeConfirmationModal = function routeConfirmationModal(promptName, promptCallback) {
  var promptProps = PromptService.popPrompt(promptName);

  if (!promptProps) {
    promptCallback(true);
    return;
  }

  var title = promptProps.title,
      message = promptProps.message;

  if (!title || !message) {
    handleTriggerEvent(promptProps, promptCallback);
  } else {
    var icon = 'mi-warning';
    var status = 'warning';
    var answer = ModalNextProvider.showConfirm({
      title: title,
      message: message,
      status: status,
      icon: icon
    });
    answer.then(function (action) {
      if (action === 'cancel') {
        promptCallback(false);
      } else {
        handleTriggerEvent(promptProps, promptCallback);
      }
    }, function () {
      promptCallback(false);
    });
  }
};

function handleTriggerEvent(promptProps, promptCallback) {
  var trigger, instance, triggerAnswer;
  return _regeneratorRuntime.async(function handleTriggerEvent$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          trigger = promptProps.trigger, instance = promptProps.instance;

          if (!(trigger && _.isFunction(trigger))) {
            _context.next = 19;
            break;
          }

          triggerAnswer = trigger();

          if (!_.isObject(triggerAnswer)) {
            _context.next = 16;
            break;
          }

          _context.prev = 4;
          _context.next = 7;
          return _regeneratorRuntime.awrap(handleAction(triggerAnswer, instance));

        case 7:
          promptCallback(instance.props.history.location === instance.props.location);
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](4);
          log.error(_context.t0);
          promptCallback(false);

        case 14:
          _context.next = 17;
          break;

        case 16:
          if (_.isBoolean(triggerAnswer)) {
            promptCallback(triggerAnswer);
          } else {
            promptCallback(true);
          }

        case 17:
          _context.next = 20;
          break;

        case 19:
          promptCallback(true);

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[4, 10]], Promise);
}